import * as types from './actionTypes';

export const fetchClaims = (unit_id, create_by) => ({
  type: types.FETCH_CLAIMS_REQUEST,
  payload: { unit_id, create_by },
});

export const saveClaim = (payload) => ({
  type: types.SAVE_CLAIM_REQUEST,
  payload,
});

export const changeClaimStatus = (payload) => ({
  type: types.CHANGE_CLAIM_STATUS_REQUEST,
  payload,
});

export const fetchClaimApprovals = (unit_id, create_by) => ({
  type: types.FETCH_CLAIM_APPROVALS_REQUEST,
  payload: { unit_id, create_by },
});

export const saveClaimApproval = (payload) => ({
  type: types.SAVE_CLAIM_APPROVAL_REQUEST,
  payload,
});

export const changeClaimApprovalStatus = (payload) => ({
  type: types.CHANGE_CLAIM_APPROVAL_STATUS_REQUEST,
  payload,
});

export const fetchViewClaimList = (unit_id, claim_id) => ({
  type: types.FETCH_VIEW_CLAIM_LIST_REQUEST,
  payload: { unit_id, claim_id }
});

export const fetchViewClaimListSuccess = (data) => ({
  type: types.FETCH_VIEW_CLAIM_LIST_SUCCESS,
  payload: data
});

export const fetchViewClaimListFailure = (error) => ({
  type: types.FETCH_VIEW_CLAIM_LIST_FAILURE,
  payload: error
});

export const sendClaimApproval = (payload) => ({
  type: types.SEND_CLAIM_APPROVAL_REQUEST,
  payload,
});
